import { AppRestClient } from "@/util/rest/clients/app-rest-client";
import { z } from "zod";
import { ZodExtended } from "@/data/zod.extended";
import { LiveShowsModels } from "./liveShows.models";
import { CommonModels } from "@/data/common/common.models";

export namespace LiveShowsApi {
export const getPast = (limit: number, order?: string, page?: number, cursor?: string, ) => { 
    return AppRestClient.get( 
        { resSchema: LiveShowsModels.LiveShowsGetPastResponseSchema }, 
        `/live-shows/past`,
        {
    params: {
        order: ZodExtended.parse(z.string().nullish(), order, { type: "query", name: "order" })
, 
        limit: ZodExtended.parse(z.number().gte(1).lte(100).default(10), limit, { type: "query", name: "limit" })
, 
        page: ZodExtended.parse(z.number().nullish(), page, { type: "query", name: "page" })
, 
        cursor: ZodExtended.parse(z.string().nullish(), cursor, { type: "query", name: "cursor" })
, 
    },
}
    )
};

export const getUpcoming = (limit: number, order?: string, page?: number, cursor?: string, ) => { 
    return AppRestClient.get( 
        { resSchema: LiveShowsModels.LiveShowsGetUpcomingResponseSchema }, 
        `/live-shows/upcoming`,
        {
    params: {
        order: ZodExtended.parse(z.string().nullish(), order, { type: "query", name: "order" })
, 
        limit: ZodExtended.parse(z.number().gte(1).lte(100).default(10), limit, { type: "query", name: "limit" })
, 
        page: ZodExtended.parse(z.number().nullish(), page, { type: "query", name: "page" })
, 
        cursor: ZodExtended.parse(z.string().nullish(), cursor, { type: "query", name: "cursor" })
, 
    },
}
    )
};

export const getCurrent = () => { 
    return AppRestClient.get( 
        { resSchema: LiveShowsModels.LiveShowsGetCurrentResponseSchema }, 
        `/live-shows/current`,
        
    )
};

export const getUploadedVideos = (limit: number, order?: string, page?: number, cursor?: string, ) => { 
    return AppRestClient.get( 
        { resSchema: LiveShowsModels.GetUploadedVideosResponseSchema }, 
        `/live-shows/uploaded-videos`,
        {
    params: {
        order: ZodExtended.parse(z.string().nullish(), order, { type: "query", name: "order" })
, 
        limit: ZodExtended.parse(z.number().gte(1).lte(100).default(10), limit, { type: "query", name: "limit" })
, 
        page: ZodExtended.parse(z.number().nullish(), page, { type: "query", name: "page" })
, 
        cursor: ZodExtended.parse(z.string().nullish(), cursor, { type: "query", name: "cursor" })
, 
    },
}
    )
};

export const findById = (id: string, ) => { 
    return AppRestClient.get( 
        { resSchema: CommonModels.LiveShowResponseDtoSchema }, 
        `/live-shows/${id}`,
        
    )
};

export const trackWatched = (id: string, ) => { 
    return AppRestClient.post( 
        { resSchema: z.void() }, 
        `/live-shows/${id}/watched`,
        
    )
};

}
